<template>
  <div class="drawer">
    <div class="user-avatar">
      <!-- GINGER-20260711-v1.4.29: read user data from Vuex curUser (reactive, single source of truth).
           Replaces the local `user` data + async getLoggedInUser() race that caused the "Unknown" role display.
           v-if guards handle the case where currentUser is null (pre-login / pre-restoreSession). -->
      <div v-if="currentUser" class="avatar-details">
        <div style="display: flex; align-items: center; justify-content: center;">
          <font-awesome-icon class="icon" icon="fa-solid fa-user"/>
          <h5>{{ currentUser.username }}</h5>
        </div>
        <p>{{ currentUser.role }}</p>
      </div>
    </div>
    <div class="menu-wrapper">
      <div class="accordion menu" id="accordionPanelsStayOpenExample">
        <div class="accordion-item" v-if="isUpdateAvailable">
          <a @click="updateApp">
            <div class="d-flex flex-column text-center">
              Update Is Available
              <span class="text-sm" @click="updateApp">Click to Update</span>
            </div>
          </a>
        </div>

        <!-- GINGER-20260711-v1.4.29: navbar gate uses currentUser.wallets.length. With v1.4.27
             loadCurrentUserWallets was hitting /get-all-wallets (directory), so this gate passed
             for every user. v1.4.29 makes loadCurrentUserWallets call /getWallet/{id} (per-user),
             so the gate now correctly shows Dashboard only for users with their own wallets.
             Merchant (id=1) gets [Main wallet] from BE → Dashboard shows for them too. -->
        <router-link  class="route-btn w-100 bg-transparent" :to="{ name: 'Dashboard' }" @click.native="back" v-if="currentUser && currentUser.wallets && currentUser.wallets.length">
          <!--          <font-awesome-icon class="icon" icon="fa-solid fa-house"/>-->
          <!--          Dashboard-->
          <a  class="route-btn border w-100 bg-transparent btn-cont">
            <font-awesome-icon class="icon" icon="fa-solid fa-house"/>
            Dashboard
          </a>
        </router-link>
        <!--        v-if="currentUser && currentUser.wallets && currentUser.wallets.length"-->
        <router-link  class="route-btn w-100 bg-transparent" :to="{ name: 'wallet' }" @click.native="back" v-if="currentUser && currentUser.wallets && currentUser.wallets.length">
          <!--          <font-awesome-icon class="icon" icon="fa-solid fa-money-bills"/>-->
          <!--          Wallet history-->
          <a  class="route-btn border w-100 bg-transparent btn-cont">
            <font-awesome-icon class="icon" icon="fa-solid fa-money-bills"/>
            Wallet history
          </a>
        </router-link>
        <router-link class="route-btn w-100 bg-transparent" :to="{ name: 'SelectRequest' }" @click.native="back">
          <!--          <font-awesome-icon class="icon" icon="fa-solid fa-plus"/>-->
          <!--          Make Request-->
          <a  class="route-btn border w-100 bg-transparent btn-cont">
            <font-awesome-icon class="icon" icon="fa-solid fa-plus"/>
            Make Request
          </a>
        </router-link>
        <router-link class="route-btn w-100 bg-transparent" :to="{ name: 'Funds' }" @click.native="back">
          <!--          <font-awesome-icon class="icon" icon="fa-solid fa-envelope"/>-->
          <!--          My Requests-->
          <a  class="route-btn border w-100 bg-transparent btn-cont">
            <font-awesome-icon class="icon" icon="fa-solid fa-envelope"/>
            My Requests
          </a>
        </router-link>
        <router-link class="route-btn w-100 bg-transparent" :to="{ name: 'DeptManager' }" @click.native="back" v-if="isManager === true">
          <a  class="route-btn border w-100 bg-transparent btn-cont">
            <font-awesome-icon class="icon" icon="fa-solid fa-user"/>
            Manager Approvals
          </a>
        </router-link>
        <router-link class="route-btn w-100 bg-transparent" :to="{ name: 'UserRequests' }" @click.native="back" v-if="currentUser && currentUser.wallets && currentUser.wallets.length">
          <a  class="route-btn border w-100 bg-transparent btn-cont">
            <font-awesome-icon class="icon" icon="fa-solid fa-chart-simple"/>
            Report
          </a>
        </router-link>
        <router-link class="route-btn w-100 bg-transparent" :to="{ name: 'settings' }" @click.native="back">
          <a  class="route-btn border w-100 bg-transparent btn-cont">
            <svg
                class="settings-btn"
                xmlns="http://www.w3.org/2000/svg"
                height="30"
                viewBox="0 -960 960 960"
                width="30"
                fill="#606d77"
            >
              <path class="icons"
                    d="m370-80-16-128q-13-5-24.5-12T307-235l-119 50L78-375l103-78q-1-7-1-13.5v-27q0-6.5 1-13.5L78-585l110-190 119 50q11-8 23-15t24-12l16-128h220l16 128q13 5 24.5 12t22.5 15l119-50 110 190-103 78q1 7 1 13.5v27q0 6.5-2 13.5l103 78-110 190-118-50q-11 8-23 15t-24 12L590-80H370Zm70-80h79l14-106q31-8 57.5-23.5T639-327l99 41 39-68-86-65q5-14 7-29.5t2-31.5q0-16-2-31.5t-7-29.5l86-65-39-68-99 42q-22-23-48.5-38.5T533-694l-13-106h-79l-14 106q-31 8-57.5 23.5T321-633l-99-41-39 68 86 64q-5 15-7 30t-2 32q0 16 2 31t7 30l-86 65 39 68 99-42q22 23 48.5 38.5T427-266l13 106Zm42-180q58 0 99-41t41-99q0-58-41-99t-99-41q-59 0-99.5 41T342-480q0 58 40.5 ```html
                  99t99.5 41Zm-2-140Z"
              ></path>
            </svg>
            Settings
          </a>
        </router-link>

      </div>
    </div>
    <!-- Logout button at the bottom -->
    <!--    <button class="Btn" @click="logOut">-->
    <!--      <div class="sign"><svg viewBox="0 0 512 512"><path d="M377.9 105.9L500.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L377.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1-128 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM160 96L96 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-53 0-96-43-96-96L0 128C0 75 43 32 96 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32z"></path></svg></div>-->
    <!--      <div class="text">Logout</div>-->
    <!--    </button>-->

    <!--    <button class="Btn">-->

    <!--      <div class="sign"><svg viewBox="0 0 512 512"><path d="M377.9 105.9L500.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L377.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1-128 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM160 96L96 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-53 0-96-43-96-96L0 128C0 75 43 32 96 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32z"></path></svg></div>-->

    <!--      <div class="text">Logout</div>-->
    <!--    </button>-->
    <div>
      <button class="logout-btn" @click="logOut">Logout</button>
    </div>

  </div>
</template>

<script>
import { Storage } from "@/Services/Storage";
import axios from "axios";

export default {
  name: "NavigationDrawer",
  // GINGER-20260711-v1.4.29: dropped `this.getLoggedInUser()` from beforeMount. That async call
  // was the root cause of the "user type not showing" symptom — it set `this.user = await Storage...`
  // AFTER the template rendered, so `{{ user.role }}` displayed the data() default 'Unknown'.
  // Navbar now reads currentUser (computed from Vuex) which is reactive and populated immediately
  // after login commits via setCurrentUser (or via restoreSession on app boot).
  beforeMount() {
    this.verifyManger();
  },
  data() {
    return {
      isManager: false,
      checkManager: [],
      // GINGER-20260711-v1.4.29: removed local `user: { username, role, wallet }` data field.
      // Single source of truth for navbar user state is now `currentUser` computed below.
    };
  },
  props: {
    close: {
      type: Function,
      required: true,
    },
  },
  created() {
    this.checkIsManger();
  },
  computed: {
    isUpdateAvailable() {
      return this.$store.getters.getUpdateAvailability;
    },
    // GINGER-20260711-v1.4.29: curUser preserved for existing checkIsManger() guard
    // (line 211 reads this.curUser.id). The new `currentUser` alias is what the template uses.
    curUser() {
      return this.$store.getters.getCurrentUser;
    },
    // Template-readable alias of the Vuex state. Null is a valid state (pre-login / pre-hydration);
    // template v-if guards handle that case. Reactive — auto-updates when validateUser2 commits
    // current_user via setCurrentUser, or when restoreSession hydrates on app boot.
    currentUser() {
      return this.$store.getters.getCurrentUser;
    }
  },
  methods: {
    checker() {
      console.log(this.curUser);
    },
    handleClick() {
      this.$emit("close-drawer"); // Emit event to parent
    },
    back() {
      if (this.close) {
        this.close();
      } else {
        console.log("Close not defined");
      }
    },
    updateApp() {
      this.$store.commit("setUpdateAvailability", false);
      return window.location.reload(true);
    },
    logOut() {
      Swal.fire({
        title: "Are you sure?",
        text: "You are about to log out.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, log out",
        cancelButtonText: "Cancel"
      }).then((result) => {
        if (result.isConfirmed) {
          // GINGER-20260711-v1.4.29: clearCurrentUser mutation (defined in user_module.js) already
          // wipes Vuex state.current_user AND Storage. The old explicit `this.user = {...}` was a
          // throwback to the local-data pattern that no longer exists. localStorage + Storage
          // cleanup also belt-and-braces against stale persistence.
          this.$store.commit('clearCurrentUser');
          localStorage.removeItem('isLoggedIn');
          Storage.setCurrentUser(null);
          this.$router.push({ name: "login" });
        }
      });
    },
    async verifyManger() {
      this.$utils.showLoading();
      try {
        const response = await axios.get(synergyApi + `employee/getAllDepartments`);
        this.checkManager = response.data;
      } catch (error) {
        return errorHandler.tomcatError(error)
      } finally {
        // this.checker()
        this.$utils.hideLoading();
      }
    },
    async checkIsManger() {
      // GINGER-20260710-USERID-GUARD-FIX: defense in depth against the curUser.id=undefined race.
      // If the navigation drawer mounts before restoreSession completes (or before login finishes
      // for a fresh session), curUser is null and curUser.id is undefined. Without this guard the
      // call below sends ?userid=undefined → Spring 400 "userid should be of type Integer". The
      // check simply no-ops; the drawer will re-render and the created() hook will refire checkIsManger
      // once a hydrated user becomes available on the next navigation/mount cycle.
      if (!this.curUser || this.curUser.id == null) return;
      this.$utils.showLoading();
      try {
        const response = await axios.get(ticketApi2 + `isuserManager?userid=${this.curUser.id}`);
        this.isManager = response.data;
      } catch (error) {
        return errorHandler.tomcatError(error)
      } finally {
        // this.checker()
        this.$utils.hideLoading();
      }
    },

  },

};
</script>

<style lang="scss" scoped>
.page {
  background: linear-gradient(0deg, #15356E 0%, #3F8DCD 100%) !important;
  overflow: hidden;
}

::selection {
  background: linear-gradient(0deg, #15356E 0%, #3F8DCD 100%) !important;
}

a {
  &:hover,
  &.router-link-exact-active {
    background: #f1f1f1;
    color: #3F8DCD;
    font-weight: 700;

    .icon-box {
      .icon {
        color: #3F8DCD;
      }
    }
  }
}

.disabled {
  pointer-events: none;
  display: none;
}

.drawer {
  display: flex;
  flex-direction: column;
  width: 100%;
  background: white;
  height: 100vh;
  overflow-y: auto;

  .user-avatar {
    display: inline-flex;
    width: 100%;
    background: url('/src/assets/img/play-banner.png') fixed;
    background-size: cover;
    color: white;
    min-height: 140px;
    background-color: rgba(50, 70, 80, 0.7);
    background-blend-mode: soft-light;

    .avatar {
      background: #40434A;
      min-width: 80px;
      width: 80px;
      height: 80px;
      border-radius: 50%;
    }

    .avatar-details {
      width: 100%;
      padding: 5px 5px 5px 10px;
      display: flex;
      flex-direction: column;
      align-items: start;
      justify-content: center;

      h5,
      p {
        margin: 0;
      }

      p {
        font-size: 15px;
        color: #ffffff;
        font-weight: 400;

        &:nth-child(3) {
          color: #15356E;
          font-weight: 600;
        }
      }
    }
  }
}
.menu-wrapper {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}

.menu {
  text-align: center;

  span {
    font-family: "Inter", sans-serif;
    font-size: 15px;
    font-weight: bold;
  }
}

.last-upd {
  font-weight: bold;
}

.icon {
  margin-right: 10px;
}

.route-btn {
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-weight: 600;
  padding-left: 10px;
  text-decoration: none;
  color: #1c1c1c;
  margin-bottom: 5px;
}
.route-btn:hover {
  background-color: lightgrey;
}

#footer {
  bottom: 0;
  position: fixed;
  width: 100%;
}

.not-footer {
  margin-bottom: 100px;
}


.Btn {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 45px;
  height: 45px;
  border: none;
  border-radius: 10%;
  margin-left: 10px;
  margin-top: auto;
  margin-bottom: 10px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition-duration: .3s;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.199);
  background-color: rgb(255, 65, 65);
}

/* plus sign */
.sign {
  width: 100%;
  transition-duration: .3s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sign svg {
  width: 17px;
}

.sign svg path {
  fill: white;
}
/* text */
.text {
  position: absolute;
  right: 0%;
  width: 0%;
  opacity: 0;
  color: white;
  font-size: 1.2em;
  font-weight: 600;
  transition-duration: .3s;
}
/* hover effect on button width */
.Btn:hover {
  width: 125px;

  transition-duration: .3s;
}

.Btn:hover .sign {
  width: 30%;
  transition-duration: .3s;
  padding-left: 20px;
}
/* hover effect button's text */
.Btn:hover .text {
  opacity: 1;
  width: 70%;
  transition-duration: .3s;
  padding-right: 10px;
}
/* button click effect*/
.Btn:active {
  transform: translate(2px ,2px);
}

.route-btn {
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-weight: 600;
  padding-left: 10px;
  text-decoration: none;
  color: #1c1c1c;
}

.settings-btn {
  margin-right: 10px;
  display: block;
  transition: transform 0.4s ease-in;
}
.btn-cont:hover .settings-btn {
  transform: rotate(90deg);
}
.settings-btn:active {
  animation: rot 1s linear infinite;
}
@keyframes rot {
  from {
    transform: rotate(-100deg);
  }
  to {
    transform: rotate(180deg);
  }
}

.logout-btn {
  background: #d3d3d3;
  color: #2c2c2c;
  cursor: pointer;
  padding: 1.5rem;
  border: 0;
  transition: all 0.5s;
  position: relative;
  width: 100%;
  margin: auto;
}

.logout-btn::after {
  font-weight: 400;
  position: absolute;
  left: 80%;
  top: 54%;
  opacity: 0;
  transform: translate(-50%, -50%);
  transition: all 0.5s;
  color: #ffffff; /* Will be visible on hover */
}

.logout-btn:hover {
  background: red;
  box-shadow: 0px 6px 15px #0000ff61;
  padding: 1.5rem 3rem 1.5rem 1.5rem;
  color: #ffffff;
}

.logout-btn:hover::after {
  opacity: 1;
}

</style>
